// Optional visual adapter. Panel selection and camera logic do not depend on it.
export default class InteractiveGraphicAnimations {
    static instances = new WeakMap();

    static init(root = document) {
        const mount = () => root.querySelectorAll('.interactive-graphic').forEach(element => {
            if (element.dataset.editable === 'true') return;
            if (!this.instances.has(element)) this.instances.set(element, new this(element));
        });
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});
        else mount();
    }

    constructor(element) {
        this.element = element;
        this.abort = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.players = [...element.querySelectorAll('lottie-player')];
        const options = {signal: this.abort.signal};
        element.querySelectorAll('.interactive-graphic__plus').forEach((plus, index) => {
            plus.style.setProperty('--marker-reveal-delay', `${index * 120}ms`);
        });
        element.classList.add('has-motion');
        element.addEventListener('interactivegraphic:visibility', () => this.update(), options);
        element.addEventListener('interactivegraphic:destroy', () => this.destroy(), options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.motion.addEventListener('change', () => this.update(), options);
        this.players.forEach(player => {
            player.addEventListener('ready', () => {
                player.closest('.interactive-graphic__lottie')?.classList.add('is-lottie-ready');
                this.update();
            }, options);
            player.addEventListener('error', () => {
                player.closest('.interactive-graphic__lottie')?.classList.remove('is-lottie-ready');
            }, options);
        });
        this.update();
    }

    update() {
        const visible = this.element.classList.contains('is-in-view');
        if (visible || this.motion.matches) this.element.classList.add('is-revealed');
        const running = visible && !document.hidden && !this.motion.matches;
        this.element.classList.toggle('is-motion-playing', running);
        this.players.forEach(player => {
            if (!player.closest('.is-lottie-ready')) return;
            if (running) player.play();
            else player.pause();
        });
    }

    destroy() {
        this.abort.abort();
        this.players.forEach(player => { if (typeof player.pause === 'function') player.pause(); });
        this.element.classList.remove('has-motion', 'is-revealed', 'is-motion-playing');
        InteractiveGraphicAnimations.instances.delete(this.element);
    }
}
